import qs from 'qs';
import axios from '../axios';
import { checkResponse, checkResponseErr, getProjectId } from '../utils';
import { apiV1 } from '../utils/constant';

function clearSessionProject(asyncFunc) {
  return (...params) => {
    sessionStorage.removeItem(`/api/v1/projects/${getProjectId()}`);
    return asyncFunc(...params);
  };
}
/**
 * @function getProjectList
 * @desc 获取项目信息
 * @param {Number} projectId 项目id
 * @returns {Object} 返回项目信息
 * @returns {String} title 项目名称
 * @returns {String} description 项目说明
 */
function getProjectList() {
  return axios.get(`${apiV1}/projects`).then(checkResponse);
}
/**
 * @function editProjectName
 * @desc 修改项目标题
 * @param {Number} projectId 项目id
 * @param {Object} data 项目信息
 * @param {String} data.title 项目名称
 * @param {String} data.description 项目说明
 * @returns {Object} 返回项目信息
 */
// function editProjectName(data) {
//   return axios
//     .put(`${apiV1}/projects/${getProjectId()}`, {
//       data,
//     })
//     .then(checkResponse);
// }
const editProjectName = clearSessionProject(function editProjectName(data) {
  return axios
    .put(`${apiV1}/projects/${getProjectId()}`, {
      data,
    })
    .then(checkResponse);
});
/**
 * @function projectIDstr
 * @desc 填充项目id四位
 * @param {Number} projectId 项目id
 * @returns {Object} 返回项目
 */
function projectIDstr() {
  return axios.get(`${apiV1}/projects/${getProjectId()}/project_id_str`).then(checkResponse);
}

/**
 * @function addProject
 * @desc 根据模板创建项目
 * @param {Object} data {title：项目名称，tpl_id：模板id，description：项目描述，mode：创建模式，固定为：from_tpl}
 * @returns {Object}
 */
//  根据模板创建项目
function addProject(data) {
  return axios.post(`/api/v1/projects`, { data }).then(checkResponse);
}
/**
 * @function addProjectFinished
 * @desc 项目初始化完成
 * @returns {Object}
 */
function addProjectFinished() {
  return axios.put(`/api/v1/projects/${getProjectId()}/finished`).then(checkResponse);
}

/**
 * @function getProjectInfo
 * @desc 项目具体信息方法
 * @param {Number} projectId 项目id
 * @returns {Object} data 返回基本信息
 * @returns {Number} data.id 返回案例tnode_ucase_id
 * @returns {String} data.title 返回案例标题
 * @returns {String} data.description 返回案例描述
 * @returns {Object} data.images 返回案例图片
 * @returns {Number} data.ucase_id 返回案例案件来源ID
 * @returns {Number} data.sequence 返回案例顺序(数字越大越排在后边)
 */
async function getProjectInfo(data) {
  return sessionCache(`/api/v1/projects/${getProjectId()}`, data);
}

async function sessionCache(url, data) {
  let item = null;

  const str = sessionStorage.getItem(url);
  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
  str != null && (item = JSON.parse(str));

  if (item == null) {
    item = await axios.get(url, data).then(checkResponse);
    sessionStorage.setItem(url, JSON.stringify(item));
  }

  return item;
}

/**
 * @function getProjectInfoById
 * @desc 项目具体信息方法
 * @param {Number} projectId 项目id
 */
function getProjectInfoById(id) {
  return axios.get(`/api/v1/projects/${id}`).then(checkResponse);
}
/**
 * @function updateProjectInfo
 * @desc 更新项目信息
 * @param {Object} data {status：如果创建完成（发布），只需将status 改为 1，未发布，默认状态为 0，title：项目名称，description：项目描述，mode：创建模式，固定为：from_tpl}
 * @returns {Object}
 */

// function updateProjectInfo(data) {
//   return axios.put(`/api/v1/projects/${getProjectId()}`, { data }).then(checkResponse);
// }
const updateProjectInfo = clearSessionProject(function updateProjectInfo(data) {
  return axios.put(`/api/v1/projects/${getProjectId()}`, { data }).then(checkResponse);
});
/**
 * @function recoverProject
 * @desc 恢复已删除的项目
 * @param {Object}
 * @returns {Object}
 */
function recoverProject(id, data) {
  return axios.put(`/api/v1/projects/${id}`, { data }).then(checkResponse);
}

/**
 * @function getProId
 * @desc 得到项目projectID方法
 * @param 无
 * @returns {Number} projectID 返回项目id
 */
function getProId() {
  return axios.get(`/api/v1/projects`).then(checkResponse).catch(checkResponseErr);
}

/** @function getProjectMsg
 *  @desc 获取项目信息
 *  @returns {Object} 项目信息
 */
function getProjectMsg() {
  return axios
    .get('/api/v1/projects?view=config&only=data')
    .then(checkResponse)
    .catch(checkResponseErr);
}

function getProjectPubInfo() {
  const { id } = qs.parse(document.location.search.split('?')[1]);
  if (!id) {
    return Promise.resolve({});
  }
  return axios.get(`${apiV1}/projects/${id}/public_info`).then(checkResponse);
}

/**
 * @function getProjectTemplate
 * @desc 获取项目模板
 */
function getProjectTemplate() {
  return axios.get(`${apiV1}/projects/templates`).then(checkResponse);
}

/**
 * @function configSwitch
 * @desc 项目可选功能的开关
 * @param {String} switch task (string) - 任务，attendance - 出勤率，navigation - 导航，gis - 地图，face_recognize - 人脸识别
 * @param {String} turn  on  - 开启 off  - 关闭
 */
function configSwitch(fun, status) {
  return axios
    .put(`${apiV1}/projects/${getProjectId()}/config_switch?switch=${fun}&turn=${status}`)
    .then(checkResponse);
}
/**
 * @function queryProjectList
 * @desc 根据条件查询项目
 * @param {String} 查询条件
 */
function queryProjectList(params) {
  return axios.get(`${apiV1}/projects?${params}`).then(checkResponse);
}
/**
 * @function deleteProject
 * @desc 删除项目
 * @param {String} 项目id
 */
function deleteProject(id) {
  return axios.delete(`${apiV1}/projects/${id}`).then(checkResponse);
}
/**
 * @function checkCompanyCustomize
 * @desc 获取企业是否开启企业定制
 * @param {String} 项目id
 */
function checkCompanyCustomize(id) {
  return axios.get(`${apiV1}/projects/${id}/company_customize`).then(checkResponse);
}
/**
 * @function checkCompanyCustomize
 * @desc 获取用户企业是否开启企业定制
 * @param {String} 项目id
 */
function checkUserCompanyCustomize(id) {
  return axios.get(`${apiV1}/projects/${id}/users/company_customize`).then(checkResponse);
}
/**
 * @function newTypicalCase
 * @desc 初始化典型案例接口
 * @param {String} 项目id
 */
function newTypicalCase(id) {
  return axios.post(`${apiV1}/projects/${id}/typicals`).then(checkResponse);
}

export {
  clearSessionProject,
  getProjectList,
  editProjectName,
  projectIDstr,
  addProject,
  addProjectFinished,
  getProjectInfo,
  updateProjectInfo,
  getProId,
  getProjectMsg,
  getProjectPubInfo,
  getProjectTemplate,
  configSwitch,
  queryProjectList,
  deleteProject,
  checkCompanyCustomize,
  checkUserCompanyCustomize,
  recoverProject,
  getProjectInfoById,
  newTypicalCase,
};
